import api from "../helpers/api";

class IndustryService{

      
    async create_industry(data) {
        
        return await api.post(`/industries`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response.data.data;
        });
    }
    
    async get_industries(page = 1){
        return await api.get(`industries?page=${page}`).then(
            response => {
                return response.data
            }
        )
    }

    async search_industry(query) {
        try {
            const response = await api.get(`/industry/search`, {
            params: { q: query },
            });
            return response.data;
        } catch (error) {
            console.error("Error searching industry:", error);
            throw error;
        }
    }

   
    async get_industry(id){
        return await api.get(`industries/${id}`).then(
            response => {
                return response.data
            }
        )
    }

    async update_industry(data){
        return await api.put(`industries/${data.id}`,data).then(
            response => {
                return response.data
            }
        )
    }

    async delete_industry(id){
        return await api.delete(`industries/${id}`).then(
            response => {
                return response.data
            }
        )
    }

    //get 
    async actions_by_industry(yearParam){
        return await api.get(`/charts/industries-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

    //get industry company distribution 
    async industry_company_distribution(){
        return await api.get(`/industry-company-distribution`).then(
            response => {
                return response.data
            }
        )}

    //get industry statisticss 
    async top_industry_actions(yearParam){
        return await api.get(`/top-industries-by-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }
    //get industry statisticss 
    async monthly_industry_actions(yearParam){
        return await api.get(`/monthly-industry-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }

    //get industry statisticss 
    async top_company_industry_actions(yearParam){
        return await api.get(`/top-companies-industry-actions/${yearParam}`).then(
            response => {
                return response.data
            }
        )
    }


   
}
export default new IndustryService;